// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RenderingsRouteImport } from './routes/renderings'
import { Route as IndexRouteImport } from './routes/index'

const RenderingsRoute = RenderingsRouteImport.update({
            id: '/renderings',path: '/renderings',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,RenderingsRoute: RenderingsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)